export default function Testimonials() {
  const testimonials = [
    {
      stars: 5,
      text: "I was quoted £14,000 by a private clinic in London for full-arch implants. I ended up paying just under £9,000 in Budapest — including flights and two hotel stays. The checklist from this site helped me ask exactly the right questions before I committed to anything. I wouldn't have felt confident going without it.",
      author: "Sarah M.",
      location: "Birmingham, UK · Full Arch (All-on-6), Hungary",
    },
    {
      stars: 5,
      text: "Did a lot of research before choosing a clinic in Istanbul. The destination quiz pointed me towards Turkey for cosmetic work and flagged exactly what to look for. Ten veneers, one week abroad, and I saved around £3,500 versus what I was quoted at home. The quality has been brilliant — 18 months on and no issues.",
      author: "James T.",
      location: "Manchester, UK · Porcelain Veneers, Turkey",
    },
    {
      stars: 4,
      text: "Chose Poland after using the quiz — it matched my situation perfectly. EU-regulated clinic, English-speaking dentist, transparent pricing with everything itemised upfront. Only two hours on the plane from Bristol. Crowns and a bridge done in two visits. Would absolutely recommend as a sensible, lower-risk option.",
      author: "Louise K.",
      location: "Bristol, UK · Crowns & Bridge, Poland",
    },
  ];

  return (
    <section className="bg-background-100 py-16 md:py-20 lg:py-24" id="testimonials">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3 block">
            Patient Stories
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            What Others Have Experienced
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-2xl">
            Real patients share their journeys. <em>Names changed for privacy.</em>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-10">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="bg-background-50 border border-dashed border-background-300 rounded-xl p-5 md:p-6"
              >
                <div className="flex items-center gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, si) => (
                    <span
                      key={si}
                      className={`w-4 h-4 flex items-center justify-center text-sm ${
                        si < t.stars ? "text-accent-500" : "text-background-300"
                      }`}
                    >
                      <i
                        className={
                          si < t.stars ? "ri-star-fill" : "ri-star-line"
                        }
                      ></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="text-sm font-medium text-foreground-950">
                  — {t.author}
                </div>
                <div className="text-xs text-foreground-500 mt-1">
                  {t.location}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-accent-50 border border-accent-200/60 rounded-lg p-4 md:p-5">
            <p className="text-sm text-accent-900 leading-relaxed">
              <span className="font-semibold">Disclaimer:</span> Dental Safety Abroad is an independent information resource. We are not a dental clinic, treatment provider, or medical adviser. Testimonials are illustrative. Always seek professional dental advice before travelling for treatment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}